import React, { useState, useEffect, Fragment } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUserPlus, faExclamationTriangle, faClone, faArrowRightFromBracket, faEllipsisVertical, faTrash, faQrcode, faStar, faDownload, faUsers, faPenToSquare, faCalendar, faClock, faLocationDot, faSpinner } from '@fortawesome/free-solid-svg-icons';
import { Alert, Button, Modal, ModalHeader, ModalBody, ModalFooter, Toast, ToastHeader, ToastBody } from 'reactstrap';
import moment from 'moment';
import { NumericFormat, PatternFormat } from 'react-number-format';
import useApiFetch from '../../ApiFetch';
import { HtmlEditor } from '../shared/htmlEditor';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';

import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import TimeFromDate from '../shared/TimeFromDate';
import DownloadCSV from '../shared/DownloadCSV';
import { CSVLink, CSVDownload } from "react-csv";
import DataTable from 'react-data-table-component';
import {
    UncontrolledDropdown, DropdownToggle,
    DropdownMenu,
    DropdownItem
} from 'reactstrap';
import EventRegistrationRowGuest from './EventRegistrationRowGuest';

export default function EventRegistrationRow(props) {
    const { eventData, registration, passesUpdated, registrationDeleted, addedGuest } = props;
    const apiFetch = useApiFetch();

    const [reg, setReg] = useState(registration);
    const [eventPass, setEventPass] = useState(registration?.eventPass);

    const [newGuest, setNewGuest] = useState({
        eventId: eventData?.id ?? null,
        registrationId: registration?.id,
        email: null,
        firstName: null,
        lastName: null,
        company: null,
        phone: null
    });
    const [guests, setGuests] = useState([]);
    const [addingGuest, setAddingGuest] = useState(false);

    const [loading, setLoading] = useState(false);
    const [registrations, setRegistrations] = useState([]);

    const [modal, setModal] = useState(false);
    const [modalAddGuest, setModalAddGuest] = useState(false);

    const [validated, setValidated] = useState(false);

    const modalToggle = () => {
        if (!modal) {
            //getData();
        }
        setModal(!modal);
        setValidated(false);
    };
    const modalAddGuestToggle = () => {
        if (!modalAddGuest) {
            //getData();
        }
        setModalAddGuest(!modalAddGuest);
        setValidated(false);
    };

    useEffect(() => {
        setEventPass(registration?.eventPass);
        setReg(registration);
    }, [registration]);
    const deleteRegistration = async (reg) => {
        modalToggle();
    };
    const confirmDelete = async (reg) => {
        await apiFetch.delete('/api/registration/' + encodeURIComponent(reg.id))
            .then(resp => {

                if (registrationDeleted)
                    registrationDeleted(reg.id)

                modalToggle();

            });
    };
    const togglePass = async (active) => {
        if (eventPass || registration?.eventPass) {
            const updatedPass = { ...(eventPass ?? registration?.eventPass), active: !(eventPass ?? registration?.eventPass).active };
            // we have an eventPass record that we have to update based on 'active'
            await apiFetch.put('/api/registration/pass/' + encodeURIComponent((eventPass ?? registration?.eventPass).id), updatedPass)
                .then(resp => {
                    if (resp.data) {
                        setEventPass(resp.data);
                        let thisReg = reg;
                        thisReg.eventPass = resp.data;
                        setReg({ ...thisReg });
                    }
                })
                .catch(err => {
                    //    if (err.response && err.response && err.response.data === "Invalid Code")
                    //        setInvalidCode(true);
                });


        }
        else {
            await apiFetch.get('/api/registration/' + encodeURIComponent(reg.id) + '/pass/')
                .then(resp => {
                    if (resp.data) {
                        let thisPass = resp.data.find(p => p.registrationId === reg.id && p.eventGuestId === null);
                        setEventPass(thisPass);
                        updatedPasses(resp.data);
                    }
                })
                .catch(err => {
                    //    if (err.response && err.response && err.response.data === "Invalid Code")
                    //        setInvalidCode(true);
                });
            //    await apiFetch.post('/api/event/', registratin.eventPass)
            //        .then(resp => {
            //            if (resp.data) {
            //                navigate('/events/' + resp.data.id)
            //                hasChanges(false);
            //            }
            //            else {
            //            }
            //        })
            //        .catch(err => {
            //            if (err.response && err.response && err.response.data === "Invalid Code")
            //                setInvalidCode(true);
            //        });
        }
    };
    const updatedPasses = (passes) => {
        if (passesUpdated)
            passesUpdated(reg, passes);
    };
    const guestDeleted = (guest) => {
        let clone = [...reg?.eventGuests];
        let ix = clone.findIndex(eg => eg.id === guest.id);
        if (ix >= 0) {
            clone.splice(ix, 1);
            setReg({ ...reg, eventGuests: [...clone] });
        }
    };
    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault(); // Prevents form submission or newline
            if (newGuest && newGuest.firstName && newGuest.lastName)
                addGuest(e);
        }
    };
    const addGuest = async (e) => {
        e.preventDefault();
        e.stopPropagation();
        setAddingGuest(true);

        setGuests([...guests, newGuest]);

        await apiFetch.post('/api/event/guest', newGuest)
            .then(resp => {
                if (addedGuest) {
                    addedGuest({ ...resp.data });
                }
                let clone = [...reg?.eventGuests];
                clone.push({ ...resp.data });
                setReg({ ...reg, eventGuests: [...clone] });
                modalAddGuestToggle();
                setNewGuest({
                    eventId: eventData?.id ?? null,
                    registrationId: registration?.id,
                    email: null,
                    firstName: null,
                    lastName: null,
                    company: null,
                    phone: null
                });
                setAddingGuest(false);
            });
    };

    return (
        <>
            <tbody className="table-group-divider">
                <tr>
                    <td className="">
                        <div className="d-flex justify-content-between align-items-center">
                            {/*<UncontrolledDropdown >*/}
                            {/*    <DropdownToggle caret>Dropdown</DropdownToggle>*/}
                            {/*    <DropdownMenu>*/}
                            {/*        <DropdownItem header>Header</DropdownItem>*/}
                            {/*        <DropdownItem>Some Action</DropdownItem>*/}
                            {/*        <DropdownItem text>Dropdown Item Text</DropdownItem>*/}
                            {/*        <DropdownItem disabled>Action (disabled)</DropdownItem>*/}
                            {/*        <DropdownItem divider />*/}
                            {/*        <DropdownItem>Foo Action</DropdownItem>*/}
                            {/*        <DropdownItem>Bar Action</DropdownItem>*/}
                            {/*        <DropdownItem>Quo Action</DropdownItem>*/}
                            {/*    </DropdownMenu>*/}
                            {/*</UncontrolledDropdown>*/}
                            <UncontrolledDropdown className="">
                                <DropdownToggle data-toggle="dropdown" tag="span">
                                    <FontAwesomeIcon icon={faEllipsisVertical} style={{ cursor: 'pointer' }} />
                                </DropdownToggle>
                                <DropdownMenu tag="ul">
                                    <DropdownItem onClick={() => { deleteRegistration() }}>
                                        <FontAwesomeIcon icon={faTrash} className="me-2 opacity-50 text-danger" fixedWidth /> Delete Registration
                                    </DropdownItem>
                                    <DropdownItem onClick={() => { togglePass(!reg.eventPass?.active) }}>
                                        <FontAwesomeIcon icon={faQrcode} className={`me-2 opacity-50 ${reg.eventPass?.active ? 'text-danger' : 'text-success'}`} fixedWidth /> {reg.eventPass?.active ? 'Disable' : 'Enable'} Pass
                                    </DropdownItem>
                                    {eventData?.supportsGuests &&
                                        <>
                                            <DropdownItem divider />
                                            <DropdownItem onClick={() => { modalAddGuestToggle() }}>
                                                <FontAwesomeIcon icon={faUserPlus} className="me-2 opacity-50 text-success" fixedWidth /> Add Guest
                                            </DropdownItem>
                                        </>
                                    }
                                    {/*{registration?.eventGuests?.length > 0 &&*/}
                                    {/*    <>*/}
                                    {/*        <DropdownItem divider />*/}
                                    {/*        <DropdownItem onClick={() => { togglePass(true) }}>*/}
                                    {/*            <FontAwesomeIcon icon={faClone} className="me-2 opacity-50 text-success" fixedWidth /> Enable Passes*/}
                                    {/*        </DropdownItem>*/}
                                    {/*        <DropdownItem onClick={() => { togglePass(true) }}>*/}
                                    {/*            <FontAwesomeIcon icon={faClone} className="me-2 opacity-50 text-danger" fixedWidth /> Disable Passes*/}
                                    {/*        </DropdownItem>*/}
                                    {/*    </>*/}
                                    {/*}*/}
                                </DropdownMenu>
                            </UncontrolledDropdown>
                            <FontAwesomeIcon icon={faStar} className="text-warning" />
                        </div>
                    </td>
                    <td>
                        <div className="d-flex justify-content-between align-items-center">
                            {reg.email}
                            {reg.eventPass &&
                                <FontAwesomeIcon icon={faQrcode} className={`${reg.eventPass.active ? 'text-body-emphasis' : 'text-danger'}`} />
                            }
                        </div>
                    </td>
                    <td>{reg.firstName}</td>
                    <td>{reg.lastName}</td>
                    <td>{reg.company}</td>
                    <td>{reg.phone}</td>
                    <td className="text-center"><TimeFromDate date={reg.dateCreated} /></td>
                </tr>
                {reg?.eventGuests && reg?.eventGuests.length > 0 && reg.eventGuests.map((eg, ii) =>
                    <EventRegistrationRowGuest key={ii} eventGuest={eg} passesUpdated={updatedPasses} guestDeleted={guestDeleted} />
                )
                }
            </tbody>
            <Modal isOpen={modal} toggle={modalToggle} size="lg" fade={true} backdrop="static">
                <ModalHeader className="bg-danger text-white">
                    <FontAwesomeIcon icon={faTrash} className="pe-2" />Delete Registration?
                </ModalHeader>
                <ModalBody>
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-3 text-center">
                                <FontAwesomeIcon icon={faExclamationTriangle} className="text-danger display-1" />
                            </div>
                            <div className="col-9">
                                <h5 className="fw-bold">Are you sure you want to delete this registration?</h5>
                                <p className="text-muted">This action is <strong>permanent</strong> and cannot be undone.</p>

                                <p className="text-center">
                                    <h2 className="pt-2 mb-0">{reg.firstName} {reg.lastName}</h2>
                                    {reg.company ? <h3 className="lead">{reg.company}</h3> : null}
                                    {reg.email ? <div className="py-0">{reg.email}</div> : null}
                                    {reg.phone ? <div className="py-0">{reg.phone}</div> : null}
                                </p>

                                {reg.eventGuests &&
                                    <p className="text-center">
                                        <span className="pt-2 mb-0 text-muted h5">Guests</span><br />
                                        {reg.eventGuests.map((eg, i) =>
                                            <Fragment key={i}><span>{eg.firstName} {eg.lastName}</span><br /></Fragment>
                                        )}
                                    </p>
                                }
                            </div>
                        </div>

                    </div>
                </ModalBody>
                <ModalFooter>
                    <button type="button" className="btn btn-secondary" onClick={modalToggle}>
                        Cancel
                    </button>
                    <button type="button" className="btn btn-danger" onClick={() => confirmDelete(reg)}>
                        <FontAwesomeIcon icon={faTrash} className="me-1" />
                        Delete
                    </button>
                </ModalFooter>
            </Modal>
            <Modal isOpen={modalAddGuest} toggle={modalAddGuestToggle} size="md" fade={true} backdrop="static">
                <ModalHeader className="" toggle={modalAddGuestToggle}>
                    <FontAwesomeIcon icon={faUserPlus} className="pe-2" />Add Guest
                </ModalHeader>
                <ModalBody>
                    <div className="row g-3">
                        <div className="col-md-6">
                            <label htmlFor="firstName" className="form-label">First Name *</label>
                            <input type="text" onKeyDown={(e) => handleKeyDown(e)} className="form-control" placeholder="" name="firstName" onChange={(e) => setNewGuest({ ...newGuest, [e.target.name]: e.target.value })} value={newGuest?.firstName ?? ''} />
                        </div>
                        <div className="col-md-6">
                            <label htmlFor="lastName" className="form-label">Last Name *</label>
                            <input type="text" onKeyDown={(e) => handleKeyDown(e)} className="form-control" placeholder="" name="lastName" onChange={(e) => setNewGuest({ ...newGuest, [e.target.name]: e.target.value })} value={newGuest?.lastName ?? ''} />
                        </div>
                        <div className="col-12">
                            <label htmlFor="Company" className="form-label">Company</label>
                            <input type="text" onKeyDown={(e) => handleKeyDown(e)} className="form-control" placeholder="" name="company" onChange={(e) => setNewGuest({ ...newGuest, [e.target.name]: e.target.value })} value={newGuest?.company ?? ''} />
                        </div>
                        <div className="col-md-6">
                            <label htmlFor="email" className="form-label">Email</label>
                            <input type="email" name="email" value={newGuest?.email ?? ''} onKeyDown={(e) => handleKeyDown(e)} className="form-control" placeholder="" onChange={(e) => setNewGuest({ ...newGuest, [e.target.name]: e.target.value })} />
                        </div>
                        <div className="col-md-6">
                            <label htmlFor="phone" className="form-label">Phone</label>
                            <PatternFormat name="phone" placeholder="Phone" onValueChange={(values, sourceInfo) => {
                                if (sourceInfo.source !== 'event') {
                                    return;
                                }
                                setNewGuest({ ...newGuest, [sourceInfo.event.target.name]: values.value })
                            }} className="form-control" id="phone" format="+1 (###) ###-####" value={newGuest?.phone ?? ''} valueIsNumericString={true} allowEmptyFormatting mask="_" />
                        </div>
                    </div>
                </ModalBody>
                <ModalFooter>
                    <button type="submit" className="btn btn-primary w-auto ms-auto" disabled={!(newGuest && newGuest.firstName && newGuest.lastName && eventData?.supportsGuests)} onClick={addGuest}>
                        <FontAwesomeIcon icon={addingGuest ? faSpinner : faUserPlus} className="me-2" />
                        Add Guest
                    </button>
                </ModalFooter>
            </Modal>
        </>
    );
};
